<template>
  <el-drawer
  :title="$t('common.filters')"
  :visible.sync="visible"
  direction="rtl"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form v-model="model" label-position="top">
      <el-form-item :label="$t('reports.filters.'+predefinePeriodLabelCode)">
        <el-select v-model="model.period" popper-class="predefined_popper" value-key="code" @select="handlePeriodSelect">
          <el-option
            v-for="item in predefinedPeriod"
            :key="item.code"
            :label="$t('reports.filters.predefined.'+item.code)"
            :value="item">
            <span >{{ $t('reports.filters.predefined.'+item.code) }}</span><br>
            <span class="fs-14 secondary-text">{{ item.description }}</span>
          </el-option>
        </el-select>
        <el-date-picker
          class="mt-20"
          v-if="model.period!=null && model.period.code=='CUSTOM' && model.period.range"
          v-model="model.dateRange"
          type="daterange"
          range-separator="à"
          :start-placeholder="$t('common.startDate')"
          :end-placeholder="$t('common.endDate')">
        </el-date-picker>
        <el-date-picker
          class="mt-20"
          v-if="model.period!=null && model.period.code=='CUSTOM' && !model.period.range"
          v-model="model.date"
          type="date">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="Client" v-if="customerFilter">
        <SelectCustomer @selected="handleCustomerSelect" :customer="model.customer"></SelectCustomer>
      </el-form-item>
   </el-form>
   <div class="dialog-footer card-shadow--large">
     <el-button @click="handleClose">{{$t('common.Cancel')}}</el-button>
     <el-button type="primary" @click="save">{{$t('common.apply')}}</el-button>
   </div>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

import SelectCustomer from '@/components/customer/select-customer'

export default {
  name: 'report-filter',
	props: {
    visible : {type : Boolean},
    predefinePeriodLabelCode : {
      type : String,
      default : 'PredefinedPeriod'
    },
    predefinedPeriod : {
      type : Array,
      default : () => []
    },
    period : Object,
    endDate : String,
    startDate : String,
    date : String,
    customerFilter : {
      type  : Boolean,
      default : false
    },
    customer : {
      type : Object,
      default : null
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      model : {
        period : null,
        dateRange : [],
        customer : null,
        date : null,
      },
    };
  },components: {
    SelectCustomer
  },
  watch : {

  },
	methods: {
    handleCustomerSelect(customer){
      if(customer!=null && customer!=''){
        this.model.customer = customer;
      }else{
        this.model.customer = null;
      }

    },
    handlePeriodSelect(period){
      if(period!=null && period.code!='CUSTOM'){
        this.model.dateRange = null;
      }
    },
    save(){
      this.$emit('applyFilter',this.model);
      this.handleClose();
    },
    open(){
      this.model.period = this.period;

      if(this.date!=null)this.model.date=this.date;

      if(this.startDate!=null && this.endDate!=null){
        this.model.dateRange=[];
        this.model.dateRange.push(this.startDate);
        this.model.dateRange.push(this.endDate);
      }
      this.model.customer = this.customer;

    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
	},
	computed: {
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

.predefined_popper li{
  padding-top:10px;
  height:55px;
  line-height:18px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
